var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PosWrapper',{attrs:{"user":_vm.$attrs.user},on:{"update:user":function($event){return _vm.$set(_vm.$attrs, "user", $event)}}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }